import { createContext, useContext } from "react";

// Indica a los componentes del TPV camarero (TpvIndex, DarkKitchen) que
// están renderizándose DENTRO del preview de Apariencia TPV — no dentro
// del DashboardLayout real. Cuando es true, deben:
//   - Ignorar trucos de viewport (100vh, mt negativo para "pegarse al
//     topbar", height calculado contra el navegador).
//   - Comportarse como cualquier componente normal dentro del flujo:
//     height intrínseco, sin márgenes negativos.
// El preview envuelve <TpvIndex>/<DarkKitchen> con <TpvPreviewContext.Provider value={true}>.

export const TpvPreviewContext = createContext(false);

export function useIsTpvPreview() {
  return useContext(TpvPreviewContext);
}
